import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';

export default withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    textAlign: 'right',
  },
})(Menu);
